import { planningConstants } from '../constants';
import { hydrateReservation } from '../helpers';

export function planning(state = {}, action) {
  switch (action.type) {
    case planningConstants.LOADPLANNING_SUCCESS:
      return {
        date: action.res.date,
        dayLimit: action.res.dayLimit,
        items: action.res.items.map(res => hydrateReservation(res)),
        nextDate: action.res.nextDate,
        prevDate: action.res.prevDate,
        step: action.res.step
      };
    case planningConstants.LOADPLANNING_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}